import { render, staticRenderFns } from "./roleSelector.vue?vue&type=template&id=083bed6e&"
import script from "./roleSelector.vue?vue&type=script&lang=js&"
export * from "./roleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports